/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Memoizes a selector that only accepts routeProps (no state)
 */

import { RouteComponentProps } from 'react-router-dom'
import { routePropsEqual } from './helpers/routePropsEqual'

export type MapRouteToProps<
  Result,
  Params extends { [K in keyof Params]?: string } = object,
> = (routeProps: RouteComponentProps<Params>) => Result

// Allows for selectors that accept routeProps instead of state
export const memoizeRouteProps = <
  Result,
  Params extends { [K in keyof Params]?: string } = object,
>(
  selector: MapRouteToProps<Result, Params>
) => {
  let prevRouteProps: RouteComponentProps<Params> | undefined
  let prevValue: Result
  return (routeProps: RouteComponentProps<Params>) => {
    if (!routePropsEqual(routeProps, prevRouteProps)) {
      prevRouteProps = routeProps
      prevValue = selector(routeProps)
    }
    return prevValue
  }
}
